export const enum VALIDATION_MESSAGES {
  REQUIRED = "فیلد الزامی",
  EMAIL = "ایمیل نامعتبر",
  PHONE = "شماره همراه نامعتبر",
  GENERAL_PHONE = "شماره نامعتبر",
  NATIONALCODE = "کد ملی نامعتبر",
  POSTALCODE = "کد پستی نامعتبر",
  BANKCARTNUMBER = "شماره کارت نامعتبر",
  SHABANUMBER = "شماره شبا نامعتبر",
  ONLY_EN_NUMBERS = "لطفا فقط اعداد انگلیسی وارد کنید.",
  PASSWORDS_DO_NOT_MATCH = "رمز عبور و تکرار رمز عبور یکسان نیستند",
  ONLY_NUMBER_CHARS = "لطفا فقط مقادیر عددی وارد نمایید.",
}
